import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

/**
 *
 * @returns scrollY possition for window scroll
 */
function useScrollHandler() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = debounce(() => {
      setScrollY(window.scrollY);
    }, 200); // delay execution for 200ms. Without a debounce it will cause performance issues.
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return scrollY;
}
export default useScrollHandler;